"use client"

import { type PropsWithChildren } from "react"
import Head from "next/head"
import { useSearchParams } from "next/navigation"

import useAuthentication from "~/hooks/account/useAuthentication"
import { LoadingPage } from "~/components/ui/LoadingPage"
import { useInternalRedirects } from "~/managers/InternalRedirectsManager/hooks"

export function WithAuthentication({ children }: PropsWithChildren<{}>) {
  const searchParams = useSearchParams()
  const asPath = searchParams.get("asPath")
  const [redirects] = useInternalRedirects()
  const { isInitialLoading, data: customer } = useAuthentication(
    `${redirects?.login?.href}${asPath ? `?redirectUrl=${asPath}` : ""}`
  )

  return isInitialLoading || !customer ? (
    <LoadingPage />
  ) : (
    <>
      <Head>
        <meta key="robots" name="robots" content="noindex,nofollow" />
      </Head>
      {children}
    </>
  )
}
